module.exports = __webpack_public_path__ + "media/images/karta-c4d27bd28a60a653e9575844d5f58f68.png";